"use strict";
import s from "underscore.string";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Api from "../api/api";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
import Blocker from "./blocker";
import CarrierSetter from "./carrier_setter";
import CarrierService from "../services/carrier_service";
import ClientNotesSidebar, {
  ClientNotesSidebarTrigger
} from "./indexer/client_notes_sidebar";
import DocumentBrowser from "./react_document_browser";
import "./indexer/email_viewer";
import EmailHelper from "../helpers/email_message";
import ExceptionSender from "./exception_sender";
import IndexerHeader from "./indexer/indexer_header";
import "./indexer/load_detail_information";
import MarkEmailCompleteView from "./mark_email_complete_view";
import moment from "moment";
import PresenceList from "./presence";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { History } from "react-router";
import { EmailForwarderMixin } from "./email_forwarder";
import { NoDocumentsProgressBar } from "./progress_bars";
function isSidebarFeatureEnabled() {
  const settings = Api.Account.currentSettings();
  if (!settings) return false;
  const setting = settings["client_notes_sidebar_display"];
  return setting && setting !== "disabled";
}
function documentFromEmail(emailMessage) {
  return ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.post("/api/email_messages/" + emailMessage.id + "/create_document"),
    null,
    { caller: "EmailWithoutDocuments.documentFromEmail" }
  );
}
function exceptionsSignature() {
  return Auth.getCurrentUser().settings["exceptions_signature"] || "";
}
function quotedBody(email, signature) {
  var whiteSpace = "\n\n";
  var prefix = "\n\nat " + moment(email.created_at).format("LLL") + email.sender_address + " wrote:\n";
  return whiteSpace + signature + prefix + _.map(s.lines(email.text_body), function(line) {
    return "> " + line;
  }).join("\n");
}
function isReceivablesEmail(email) {
  function isReceivablesLabel(label) {
    return label.name == "Receivables";
  }
  return email.labels.some(isReceivablesLabel);
}
var EmailWithoutDocuments = React.createClass({
  mixins: [EmailForwarderMixin, History],
  getInitialState: function() {
    const settings = Api.Account.currentSettings();
    const setting = settings ? settings["client_notes_sidebar_display"] : void 0;
    const initialSidebarOpen = setting === "expanded";
    return {
      step: !this.props.email.document_batch_carrier_id && _.isNull(this.props.email.single_carrier) ? 0 : 1,
      sidebarOpen: initialSidebarOpen,
      carrierData: null
    };
  },
  componentDidMount: function() {
    this.loadCarrierData();
  },
  componentDidUpdate: function(prevProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    if (((_a = this.props.email) == null ? void 0 : _a.carrier_id) !== ((_b = prevProps.email) == null ? void 0 : _b.carrier_id) || ((_d = (_c = this.props.email) == null ? void 0 : _c.carrier) == null ? void 0 : _d.id) !== ((_f = (_e = prevProps.email) == null ? void 0 : _e.carrier) == null ? void 0 : _f.id) || ((_g = this.props.carrier) == null ? void 0 : _g.id) !== ((_h = prevProps.carrier) == null ? void 0 : _h.id) || ((_i = this.props.email) == null ? void 0 : _i.document_batch_carrier_id) !== ((_j = prevProps.email) == null ? void 0 : _j.document_batch_carrier_id)) {
      this.loadCarrierData();
    }
  },
  loadCarrierData: function() {
    var _a, _b, _c, _d, _e;
    const carrierId = ((_a = this.props.email) == null ? void 0 : _a.carrier_id) || ((_c = (_b = this.props.email) == null ? void 0 : _b.carrier) == null ? void 0 : _c.id) || ((_d = this.props.carrier) == null ? void 0 : _d.id) || ((_e = this.props.email) == null ? void 0 : _e.document_batch_carrier_id);
    if (carrierId && isSidebarFeatureEnabled()) {
      CarrierService.carrierWithId(carrierId).then((fullCarrier) => {
        this.setState({ carrierData: fullCarrier });
      });
    }
  },
  handleToggleSidebar: function() {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  },
  renderSidebar: function() {
    var _a;
    if (!isSidebarFeatureEnabled() || !this.state.carrierData) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      ClientNotesSidebar,
      {
        key: ((_a = this.state.carrierData) == null ? void 0 : _a.id) || "sidebar",
        warning: this.state.carrierData.warning || null,
        notes: this.state.carrierData.notes || null,
        fundingNotes: this.state.carrierData.funding_notes || null,
        verificationInstructions: this.state.carrierData.verification_instructions || null,
        isOpen: this.state.sidebarOpen,
        onToggle: this.handleToggleSidebar,
        loading: false,
        noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
      }
    );
  },
  renderSidebarTrigger: function() {
    if (!isSidebarFeatureEnabled() || !this.state.carrierData) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      ClientNotesSidebarTrigger,
      {
        warning: this.state.carrierData.warning || null,
        notes: this.state.carrierData.notes || null,
        fundingNotes: this.state.carrierData.funding_notes || null,
        verificationInstructions: this.state.carrierData.verification_instructions || null,
        onToggle: this.handleToggleSidebar,
        noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
      }
    );
  },
  getStepLabel: function() {
    return ["assignCarrier", "respondOrComplete"][this.state.step];
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      Blocker,
      {
        "data-component": "EmailWithoutDocuments",
        modalView: this.possibleEmailForwarder(this.props.email) || this.possibleMarkComplete(this.props.email)
      },
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__header" }, /* @__PURE__ */ React.createElement(
        IndexerHeader,
        {
          email: this.props.email,
          carrier: this.props.email.carrier,
          canSetCarrier: this.state.step === 1,
          setCarrier: this.startSetCarrier,
          canMarkComplete: true,
          markComplete: this.startMarkingComplete,
          actions: [["Forward Email", this.forwardEmail]]
        }
      )), /* @__PURE__ */ React.createElement(
        NoDocumentsProgressBar,
        {
          stepNumber: this.state.step,
          sidebarTrigger: this.renderSidebarTrigger()
        }
      ), /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body" }, this.renderSidebar(), /* @__PURE__ */ React.createElement("div", { className: "reply-view__main-body row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column reply-view__work-area" }, this.carrierSetterOrReply(), "\xA0"), /* @__PURE__ */ React.createElement("div", { className: "small-5 column reply-view__document-browser" }, this.emailChainViewer()), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
        PresenceList,
        {
          location: this.props.location,
          emailId: this.props.email.id
        }
      )))))
    );
  },
  emailChainViewer: function() {
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.documentModel,
        additionalComponents: this.additionalBrowserComponents(),
        location: this.props.location
      }
    );
  },
  documentFromEmailCallback: function(data) {
    const newLocation = this.props.location.query.onDone || "/dashboard";
    this.history.pushState(
      null,
      "/index-document-batches/" + data.document_batch.id,
      { onDone: newLocation }
    );
  },
  possibleMessageBrowserComponent: function() {
    const email = this.props.email;
    const emails = this.props.email && _.sortBy(
      email.parent_emails.concat(email.replies).concat(email),
      "created_at"
    ).reverse();
    if (emails.length > 0) {
      return {
        label: "Messages",
        component: EmailHelper.emailMessages(
          emails,
          documentFromEmail,
          this.documentFromEmailCallback
        )
      };
    }
  },
  additionalBrowserComponents: function() {
    return [this.possibleMessageBrowserComponent()];
  },
  // TODO: This is likely dead code
  /* eslint-disable no-undef */
  // eslint-disable-next-line local/prefer-module-level-functions -- dead code, delete rather than hoist
  documentModel: function() {
    return new GroupedDocumentBrowserModel(
      // @ts-ignore
      new DocumentBatchGroupCreator(documentBatches, function(doc) {
        return doc.carrier_invoice_id === invoiceID;
      })
    );
  },
  /* eslint-enable no-undef */
  startSetCarrier: function() {
    this.setState({ step: 0, forcedStep: true });
  },
  carrierSetterComplete: function(e) {
    this.props.carrierSetter.onSetCarrier(e).then((result) => {
      this.setState({ step: 1 });
      this.loadCarrierData();
    });
  },
  possibleProcessOriginal: function() {
    if (this.props.documentGroup) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "/app/index-document-batches/" + this.props.documentGroup.document_batch_id + "?group_id=" + this.props.documentGroup.id,
          className: "button button--confirmation"
        },
        "Process Original Documents"
      );
    }
  },
  carrierSetterOrReply: function() {
    if (this.state.step === 0) {
      return /* @__PURE__ */ React.createElement(
        CarrierSetter,
        {
          isReceivablesEmail: isReceivablesEmail(this.props.email),
          onSetCarrier: this.carrierSetterComplete,
          carrier: this.props.carrier || {},
          isSingleCarrier: this.props.email.single_carrier
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "reply-view__body" }, /* @__PURE__ */ React.createElement("div", { className: "reply-view__header" }, /* @__PURE__ */ React.createElement("div", { className: "reply-view__header-row" }, /* @__PURE__ */ React.createElement("p", { className: "reply-view__instructions" }, "No documents were found on this email. You can either reply to this message or ignore this entry."), this.possibleProcessOriginal()), /* @__PURE__ */ React.createElement("h3", { className: "reply-view__section-title" }, "Send a Reply")), /* @__PURE__ */ React.createElement(
        ExceptionSender,
        {
          onComplete: this.props.returningMethods.onComplete,
          defaultEmail: {
            body: quotedBody(this.props.email, exceptionsSignature()),
            subject: "Re: " + this.props.email.subject
          },
          markParentComplete: true,
          emailMessageId: this.props.email.id,
          parent: this.props.email
        }
      ));
    }
  },
  cancelMarkingComplete: function() {
    this.setState({ markingComplete: false });
  },
  startMarkingComplete: function(email) {
    this.setState({ markingComplete: true });
  },
  doneMarkingComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  possibleMarkComplete: function(email) {
    if (this.state.markingComplete) {
      return /* @__PURE__ */ React.createElement(
        MarkEmailCompleteView,
        {
          email,
          onCancel: this.cancelMarkingComplete,
          onMarkCompleteFinished: this.doneMarkingComplete
        }
      );
    }
  }
});
export { EmailWithoutDocuments };
